import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

// Central axios instance - all requests go through here
export const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true, // sends JWT cookie automatically
});

// Auto-attach Authorization header from localStorage fallback
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('vc_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('vc_user'));
    } catch {
      return null;
    }
  });

  const login = async (email, password, role = 'client') => {
    const { data } = await api.post('/api/auth/login', { email, password, role });
    localStorage.setItem('vc_token', data.token);
    localStorage.setItem('vc_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('vc_token');
    localStorage.removeItem('vc_user');
    setUser(null);
    api.post('/api/auth/logout').catch(() => {});
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);